import { render, staticRenderFns } from "./DoucanUserProtocol.vue?vue&type=template&id=5337e248&scoped=true"
import script from "./DoucanUserProtocol.vue?vue&type=script&lang=js"
export * from "./DoucanUserProtocol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5337e248",
  null
  
)

export default component.exports